/*!
 * Stimpack Control - Tax Query
 *
 * @version : 1.0.0
 * @author  : Matthias Courville
 */

import { spIsBase64, spBase64Encode, spBase64Decode } from '../utilities/utilities';

(function($) {

    var spControlSidebar = function(el, options)
    {
        var _this = this,
            root = $(el);

        this.options = $.extend({
        }, options);

        this.el = {
            root                : root,
            idControl           : root.find('.sp-control-sidebar-id-control'),
            breakpointControl   : root.find('.sp-control-sidebar-breakpoints')
        };

        if (this.el.breakpointControl.length > 0)
        {
            this.el.idControl.on('change', function() {

                var selected = _this.el.idControl.find(':selected').val();

                if ('' === selected)
                {
                    _this.el.root.addClass('sp-control-sidebar-null-selected');
                }
                else if ('_NONE' === selected)
                {
                    _this.el.root.addClass('sp-control-sidebar-none-selected');
                }
                else
                {
                    _this.el.root.removeClass('sp-control-sidebar-null-selected sp-control-sidebar-none-selected');
                }
            });
        }
    };

    $.fn.spControlSidebar = function(options)
    {
        options = options || {};

        return this.each(function() {

            var _options = $(this).data('data-sp-control-sidebar');

            $(this).attr('data-sp-control-sidebar', true);

            if (_options)
            {
                if (typeof _options == 'object')
                {
                    options = $.extend({}, options, _options);
                }
                else if (spIsBase64(_options))
                {
                    options = $.extend({}, options, _options ? JSON.parse(spBase64Decode(_options)) : {});
                }
            }

            this.spControlSidebar = new spControlSidebar(this, options);
        });
    };

    // Declaration
    $('[data-sp-control-sidebar]').each(function() {
        $(this).spControlSidebar();
    });

})(jQuery);
